/**
 * Fluxo de Caixa
 *
 * Saldo Inicial
 * Outras Entradas
 * Total Receitas
 * Loop nas categorias de despesas
 * Total Despesas
 * Saldo Período
 * Saldo Total
 *
 * Cálculo: ST = SI + OE + TR - TD
 */
import { aqRelatorios } from '../utils';
import { stateContext } from '../hooks/useStore';
import { getRelatorio } from './relatorios';

export const MAX_DOCUMENTO_LENGTH = 20;

export function validarDocumento(documento: string, store: any): boolean {
  if (documento.length > MAX_DOCUMENTO_LENGTH) {
    store.notificar('O Documento não pode ter mais de 20 caracteres');
    return false;
  }
  return true;
}

export async function getFluxoDeCaixa(
  propriedadeID: number,
  ano: string,
  print?: boolean,
): Promise<void | FluxoRow[] | void> {
  // Calcula o saldo inicial de janeiro
  const movimentacoes = stateContext.state.movimentacoes;
  let total = 0;

  if (!print) stateContext.state.toggleLoader();

  movimentacoes
    ?.filter((mov) => parseInt(mov.data.substr(6, 4)) < parseInt(ano))
    .map((movimentacao) => {
      if (movimentacao.categoria.tipo === 'vendas' || movimentacao.categoria.tipo === 'outras') {
        if (movimentacao.situacao) total += movimentacao.valor_total;
        else if (!movimentacao.situacao && movimentacao.parcelas.length > 0) {
          movimentacao.parcelas.map((parcela) => {
            if (parcela.recebido) total += parcela.valor;
            return null;
          });
        }
      } else if (movimentacao.categoria.tipo === 'despesas') {
        if (movimentacao.situacao) total -= movimentacao.valor_total;
        else if (!movimentacao.situacao && movimentacao.parcelas.length > 0) {
          movimentacao.parcelas.map((parcela) => {
            if (parcela.recebido) total -= parcela.valor;
            return null;
          });
        }
      }
    });

  if (print) {
    return getRelatorio('/fluxo-de-caixa/relatorio', {
      ano,
      propriedadeID,
      saldoInicial: total,
    });
  } else {
    const request = await aqRelatorios.post('/fluxo-de-caixa/', {
      ano,
      propriedadeID,
      saldoInicial: total,
    });
    stateContext.state.toggleLoader();

    return request.data;
  }
}
